<template>
  <div class="main-container">
    <div class="header-status-bar">
      <div class="mall-logo">北国先天下</div>
      <div class="status-info">
        <span>18:05</span>
        <span>2025-09-30 星期二</span>
        <span>☁ 19-25°</span>
      </div>
    </div>
    <div class="content-area">
      <div class="left-panel">
        <MascotPanel ref="mascotPanel" />
      </div>
      <div class="right-panel">
        <OperationPanel 
            @open-chat="showChat = true" 
            @open-map="showMap = true" 
            @open-brand-list="showBrandList = true"
            @open-chat-with-context="handleOpenChatWithContext"
            @ask-question="handleAskQuestion"
        />
        <transition name="fade">
          <AIChatPanel 
            v-if="showChat" 
            ref="aiChatPanel" 
            @close="showChat = false" 
            @navigate="handleNavigate" 
            @speaking-start="handleSpeakingStart"
            @speaking-stop="handleSpeakingStop"
          />
        </transition>
        <transition name="fade">
          <BrandList 
            v-if="showBrandList" 
            @close="showBrandList = false" 
            @navigate="handleNavigate"
          />
        </transition>
        <transition name="fade">
          <div v-if="showMap" class="map-overlay">
            <div class="map-wrapper">
              <button class="close-map-btn" @click="showMap = false">×</button>
              <MapComponent ref="mapComponent" />
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import MascotPanel from './components/MascotPanel.vue'
import OperationPanel from './components/OperationPanel.vue'
import AIChatPanel from './components/AIChatPanel.vue'
import MapComponent from './components/MapComponent.vue'
import BrandList from './components/BrandList.vue'

export default {
  name: 'App',
  components: {
    MascotPanel,
    OperationPanel,
    AIChatPanel,
    MapComponent,
    BrandList
  },
  data() {
    return {
      showChat: false,
      showMap: false,
      showBrandList: false
    }
  },
  methods: {
    handleOpenChatWithContext(data) {
        this.showChat = true;
        // Wait for next tick to ensure component is rendered
        this.$nextTick(() => {
            if (this.$refs.aiChatPanel) {
                this.$refs.aiChatPanel.handleExternalMessage(data);
            }
        });
    },
    handleAskQuestion(question) {
        this.showChat = true;
        this.$nextTick(() => {
            if (this.$refs.aiChatPanel) {
                this.$refs.aiChatPanel.handleUserQuestion(question);
            }
        });
    },
    handleNavigate(data) {
        this.showChat = false;
        this.showMap = true;
        this.$nextTick(() => {
            if (this.$refs.mapComponent) {
                this.$refs.mapComponent.findAndSetDestination(data);
            }
        });
    },
    handleSpeakingStart() {
        if (this.$refs.mascotPanel) {
            this.$refs.mascotPanel.playAnimation('speak');
        }
    },
    handleSpeakingStop() {
        if (this.$refs.mascotPanel) {
            this.$refs.mascotPanel.playAnimation('idle');
        }
    }
  }
}
</script>

<style>
/* ... existing styles ... */
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

#app {
  height: 100%;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.main-container {
  height: 100%;
  width: 100%;
  background: linear-gradient(135deg, #d14d5e 0%, #d65db1 100%);
  display: flex;
  flex-direction: column;
}

.header-status-bar {
  height: 8vh; /* Use vh */
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 3vw;
  color: #fff;
  font-size: 1.2rem;
  flex: 0 0 auto;
}

.mall-logo {
  font-weight: bold;
  font-size: 1.5rem;
}

.status-info {
  display: flex;
  gap: 20px;
}

.content-area {
  flex: 1;
  display: flex;
  padding: 0 3vw 3vh 3vw;
  gap: 3vw;
  min-height: 0;
  overflow: hidden;
}

.left-panel {
  flex: 1.2;
  position: relative;
  /* background: rgba(0,0,0,0.1); Debugging */
}

.right-panel {
  flex: 1;
  min-width: 0;
  /* max-width removed for better responsiveness */
  position: relative; /* Ensure absolute children are positioned relative to this */
}

.map-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  z-index: 200;
  display: flex;
  justify-content: center;
  align-items: center;
}

.map-wrapper {
  width: 90%;
  height: 90%;
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
}

.close-map-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  font-size: 24px;
  cursor: pointer;
  z-index: 300;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  color: #333;
}

.close-map-btn:hover {
  background: #f0f0f0;
}

/* Transitions */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
